// 🏆 Rhythm Puzzle Achievement Definitions
// These auto-sync to Firebase when the game loads

import { AchievementDefinition } from '../services/GameAPI';

export const RHYTHM_PUZZLE_ACHIEVEMENTS: AchievementDefinition[] = [
  {
    id: "first_pattern",
    gameId: "rhythm-puzzle",
    title: "Code Revealed",
    description: "Your first rhythm pattern has been revealed! The treasure hunt begins.",
    iconUrl: "🎵",
    museCashReward: 50,
    type: "milestone",
    rarity: "common",
    implemented: true,
    sortOrder: 1,
    category: "progression"
  },
  {
    id: "lock_1", 
    gameId: "rhythm-puzzle",
    title: "Lock 1 Cracked!",
    description: "Successfully unlocked the first lock! Your rhythm skills are showing.",
    iconUrl: "🔓",
    museCashReward: 100,
    type: "achievement",
    rarity: "common", 
    implemented: true,
    sortOrder: 2,
    category: "progression"
  },
  {
    id: "lock_2",
    gameId: "rhythm-puzzle", 
    title: "Lock 2 Cracked!",
    description: "The second lock falls before your rhythm mastery! You're getting closer to the treasure.",
    iconUrl: "🔐",
    museCashReward: 125,
    type: "achievement",
    rarity: "common",
    implemented: true,
    sortOrder: 3,
    category: "progression"
  },
  {
    id: "lock_3",
    gameId: "rhythm-puzzle",
    title: "Lock 3 Cracked!", 
    description: "The final lock is broken! All that stands between you and treasure is opening the chest.",
    iconUrl: "🗝️",
    museCashReward: 150,
    type: "achievement",
    rarity: "rare",
    implemented: true,
    sortOrder: 4,
    category: "progression"
  },
  {
    id: "treasure_unlocked",
    gameId: "rhythm-puzzle",
    title: "Treasure Unlocked!",
    description: "All rhythm codes cracked! The treasure is yours! You've mastered the rhythmic puzzles.",
    iconUrl: "🏆",
    museCashReward: 100,
    type: "completion", 
    rarity: "rare",
    implemented: true,
    sortOrder: 5,
    category: "completion"
  },
  {
    id: "quick_solver",
    gameId: "rhythm-puzzle",
    title: "Quick Solver!",
    description: "Unlocked all codes quickly! Your rhythm skills are impressive and efficient.",
    iconUrl: "🎯",
    museCashReward: 150,
    type: "performance",
    rarity: "rare",
    implemented: true,
    sortOrder: 6,
    category: "skill"
  },
  {
    id: "speed_master",
    gameId: "rhythm-puzzle",
    title: "Speed Master!",
    description: "Unlocked all codes in under 2 minutes! Lightning fast rhythm recognition!",
    iconUrl: "⚡",
    museCashReward: 200,
    type: "performance",
    rarity: "epic",
    implemented: true,
    sortOrder: 7,
    category: "skill"
  }
]; 